/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CProgramLinkType {
    LINK = 'LINK',
    MAILTO = 'MAILTO',
}
